import State from 'store/State';
import { selectWidgetInstancesState } from 'widgets/store/selectors';
import { WidgetType } from 'widgets/WidgetType';
import { selectWidgets } from 'layout/store/selectors';
import uniq from 'lodash/uniq';
import { buildMyPortfolioCapsulesConfigSlice } from 'widgets/myPortfolioCapsules/store/config/configSlice';
import { TopicType } from 'widgets/myPortfolioCapsules/topics/TopicType';
import {
    getTopic,
    isValidTopic,
} from 'widgets/myPortfolioCapsules/topics/Topic';
import { selectIsFeatureEnabled } from 'app/store/featureToggles/selectors';

export const selectMyPortfolioCapsulesWidgetsState = (state: State) =>
    selectWidgetInstancesState(state)[WidgetType.MY_PORTFOLIO_CAPSULES];

export const selectMyPortfolioCapsulesState = (
    state: State,
    widgetKey: string
) => selectMyPortfolioCapsulesWidgetsState(state)[widgetKey];

export const selectAllActiveTopics: (state: State) => TopicType[] = (state) => {
    const configSlice = buildMyPortfolioCapsulesConfigSlice();
    const activeWidgets = selectWidgets(state, true).filter(
        (w) => w.type === WidgetType.MY_PORTFOLIO_CAPSULES
    );

    return uniq(
        activeWidgets
            .map(
                (w) =>
                    configSlice.selectors.selectConfigState(state, w.id).topic
            )
            .filter((t) => t !== undefined)
            .filter((t) => isValidTopic(t!))
            .filter((t) => {
                const ft = getTopic(t!).featureToggle;
                return !ft || selectIsFeatureEnabled(state, ft);
            }) as TopicType[]
    );
};
